import Tabby from 'tabbyjs'

/**
 * On-Demand component.
 * @author Dayne Coulson-Hoffacker
 */
export default class OnDemand {
  /**
   * Constructs a new OnDemand component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    const tabs = new Tabby('[data-tabs]');
  }
}



// WEBPACK FOOTER //
// ./components/section/on-demand/index.js